"use client";

import config from "@/config";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/providers/auth";
import { NavLink } from "react-router-dom";

const formSchema = z.object({
    username: z.string().min(1, {
        message: "You must specify a username"
    }),
    password: z.string().min(1, {
        message: "You must specify a password"
    })
});

export function LoginForm({ onSignIn }: { onSignIn: () => void }) {
    const { signin } = useAuth();

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            username: "",
            password: ""
        }
    });

    const onSubmit = async (values: z.infer<typeof formSchema>) => {
        await signin(values.username, values.password);
        await onSignIn();
    };

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="mb-5 space-y-3">
                    <FormField
                        control={form.control}
                        name="username"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel required>Identifiant</FormLabel>
                                <FormControl>
                                    <Input placeholder="walter" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="password"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel required>Mot de passe</FormLabel>
                                <FormControl>
                                    <Input type="password" placeholder="•••••" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div>
                <div className="space-x-2">
                    <Button type="submit">Connexion</Button>
                    <Button type="button" variant="outline" asChild>
                        <NavLink to={`${config.BACKEND_URL[import.meta.env.VITE_RELEASE_STAGE as keyof typeof config.BACKEND_URL]}/auth/login/sso/`}>Connexion par SSO</NavLink>
                    </Button>
                </div>
            </form>
        </Form>
    );
}
